module.exports = __webpack_public_path__ + "img/lock-04.e93ac510.svg";